import { render, staticRenderFns } from "./LawyerOfficeForm.vue?vue&type=template&id=59db6d90&scoped=true"
import script from "./LawyerOfficeForm.vue?vue&type=script&lang=js"
export * from "./LawyerOfficeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db6d90",
  null
  
)

export default component.exports